import { graphql } from "@/graphql/codegen"

graphql(`
  query ShipFromPreferenceList($input: ShipFromPreferenceListInput!) {
    shipFromPreference {
      list(input: $input) {
        __typename
        ... on ShipFromPreferenceListSuccess {
          shipFromPreferences {
            shipToLocationId
            shipFromWarehouseId
            shipFromWarehouse {
              externalSystemId
              location {
                name
                description
              }
            }
            estimatedTransitDays
            isPreferred
          }
        }
        ... on ShipFromPreferenceListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
